<template>
  <div
    class="heat-source"
    @mousewheel="rollImg($event)"
    @DOMMouseScroll="rollImg($event)"
  >
    <vue-drag-resize
      :isResizable="false"
      :style="{
        width: '1680px',
        height: '1000px',
        position: 'relative',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        zoom: mapZoom + '%',
        '-moz-transform-origin': 'top left',
        '-moz-transform': 'scale(' + mapZoom / 100 + ')',
      }"
    >
      <div class="img-box">
        <span class="hydrating">自来水补水</span>
        <div class="title-001">
          <span class="title"
            ><i
              :class="{ alarm: deviceType149.monitorType010004 === 'true' }"
            ></i>
            1#一次循环泵</span
          >
          <span class="title"
            ><i
              :class="{ alarm: deviceType150.monitorType010004 === 'true' }"
            ></i>
            2#一次循环泵</span
          >
          <div
            class="circulatingPump1"
            :class="{ stop: deviceType149.monitorType001001 === 'false' }"
          ></div>
          <div
            class="circulatingPump2"
            :class="{ stop: deviceType150.monitorType001001 === 'false' }"
          ></div>
          <p>
            <label>累计时间</label>
            <span>{{ deviceType149.monitorType014154 || 0 }}</span>
          </p>
          <p>
            <label>累计时间</label>
            <span>{{ deviceType150.monitorType014154 || 0 }}</span>
          </p>
        </div>
        <div class="title-002">
          <span>接市政天然气</span>
          <div>
            <p>1#锅炉</p>
            <p>
              <label>锅炉状态：</label>
              <span
                v-if="deviceType417.monitorType014131 === '1'"
                class="span-btn alarm"
                >报警</span
              >
              <span
                v-else-if="deviceType417.monitorType014131 === '3'"
                class="span-btn stop"
                >关机</span
              >
              <span
                v-else-if="deviceType417.monitorType014131 === '0.0'"
                class="span-btn"
                >待命</span
              >
              <span v-else class="span-btn">运行</span>
            </p>
            <p>
              <label>炉水温度：</label
              ><span>{{ deviceType417.monitorType014132 || 0 }}℃</span>
            </p>
            <p>
              <label>采暖温度：</label
              ><span>{{ deviceType417.monitorType014133 || 0 }}℃</span>
            </p>
            <p>
              <label>热水温度：</label
              ><span>{{ deviceType417.monitorType014133 || 0 }}℃</span>
            </p>
            <p>
              <label>累计时间：</label
              ><span>{{ deviceType417.monitorType014154 || 0 }}</span>
            </p>
          </div>
        </div>
        <div class="img-001">
          <p>
            <span v-if="deviceType417.monitorType014150 === '0.0'">正常</span>
            <span class="stop" v-else>报警</span>
          </p>
          <p>
            <span v-if="deviceType418.monitorType014150 === '0.0'">正常</span>
            <span class="stop" v-else>报警</span>
          </p>
          <div
            class="boiler1"
            :class="{ stop: deviceType417.monitorType014150 === '1' }"
          />
          <div
            class="boiler2"
            :class="{ stop: deviceType418.monitorType014150 === '1' }"
          />
        </div>
        <div class="title-003">
          <div>
            <p>2#锅炉</p>
            <p>
              <label>锅炉状态：</label>
              <span
                v-if="deviceType418.monitorType014131 === '1'"
                class="span-btn alarm"
                >报警</span
              >
              <span
                v-else-if="deviceType418.monitorType014131 === '3'"
                class="span-btn stop"
                >关机</span
              >
              <span
                v-else-if="deviceType418.monitorType014131 === '0.0'"
                class="span-btn"
                >待命</span
              >
              <span v-else class="span-btn">运行</span>
            </p>
            <p>
              <label>炉水温度：</label
              ><span>{{ deviceType418.monitorType014132 || 0 }}℃</span>
            </p>
            <p>
              <label>采暖温度：</label
              ><span>{{ deviceType418.monitorType014133 || 0 }}℃</span>
            </p>
            <p>
              <label>热水温度：</label
              ><span>{{ deviceType418.monitorType014133 || 0 }}℃</span>
            </p>
            <p>
              <label>累计时间：</label
              ><span>{{ deviceType418.monitorType014154 || 0 }}</span>
            </p>
          </div>
        </div>
        <div class="img-002">
          <span class="title"
            ><i
              :class="{ alarm: deviceType146.monitorType010004 === 'true' }"
            ></i>
            1#二次循环泵</span
          >
          <span class="title"
            ><i
              :class="{ alarm: deviceType147.monitorType010004 === 'true' }"
            ></i>
            2#二次循环泵</span
          >
          <span class="title"
            ><i
              :class="{ alarm: deviceType148.monitorType010004 === 'true' }"
            ></i>
            3#二次循环泵</span
          >
          <div
            class="circulatingPump3"
            :class="{ stop: deviceType146.monitorType001001 === 'false' }"
          />
          <div
            class="circulatingPump4"
            :class="{ stop: deviceType147.monitorType001001 === 'false' }"
          />
          <div
            class="circulatingPump5"
            :class="{ stop: deviceType148.monitorType001001 === 'false' }"
          />
          <p>
            <label>累计时间</label>
            <span>{{ deviceType146.monitorType014154 || 0 }}</span>
          </p>
          <p>
            <label>累计时间</label>
            <span>{{ deviceType147.monitorType014154 || 0 }}</span>
          </p>
          <p>
            <label>累计时间</label>
            <span>{{ deviceType148.monitorType014154 || 0 }}</span>
          </p>
        </div>
        <span class="trap">分水器</span>
        <span class="collector">集水器</span>
        <img width="1552px" :src="img" />
      </div>
    </vue-drag-resize>
  </div>
</template>

<script>
import { selectDeviceListByCategoryId } from '@/api/business/base/tenant/map'

export default {
  data() {
    return {
      img: require("@/assets/wuhai_img/bg2.png"),
      deviceInfo: {
        monitorList: []
      },
      mapZoom: 100,
      minZoom: 80,
      maxZoom: 200,
      loading: false,
      deviceType417: {
        monitorType014154: null,
        monitorType014131: null,
        monitorType014132: null,
        monitorType014133: null,
        monitorType014134: null,
        monitorType014150: null
      },
      deviceType418: {
        monitorType014154: null,
        monitorType014131: null,
        monitorType014132: null,
        monitorType014133: null,
        monitorType014134: null,
        monitorType014150: null
      },
      deviceType146: {
        monitorType001001: null,
        monitorType010004: null,
        monitorType014154: null
      },
      deviceType147: {
        monitorType001001: null,
        monitorType010004: null,
        monitorType014154: null
      },
      deviceType148: {
        monitorType001001: null,
        monitorType010004: null,
        monitorType014154: null
      },
      deviceType150: {
        monitorType001001: null,
        monitorType010004: null,
        monitorType014154: null
      },
      deviceType149: {
        monitorType001001: null,
        monitorType010004: null,
        monitorType014154: null
      }

    }
  },
  created() {
    selectDeviceListByCategoryId({ categoryId: 16 }).then(res => {
      console.log(res)
      res.map(v => {
        this.initMonitorRedisData(v.monitorList, v.deviceId)
        console.log(v.deviceId, this["deviceType" + v.deviceId])
      })
    })
  },
  methods: {
    initMonitorRedisData(monitorList, deviceId) {
      monitorList.map(v => {
        this.findMonitorTypeValue(v.monitorType, monitorList, deviceId);
      })
    },
    findMonitorTypeValue(monitorType, monitorList, deviceId) {
      let monitorObj = monitorList.find((item) => {
        return item.monitorType == monitorType;
      })
      if (+monitorObj.value) {
        this["deviceType" + deviceId]['monitorType' + monitorType] = (+monitorObj.value).toFixed(0)
      } else {
        this["deviceType" + deviceId]['monitorType' + monitorType] = monitorObj.value
      }

    },
    //地图放大缩小
    rollImg(event) {
      let zoom = parseInt(this.mapZoom) || 100;
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom
            wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动
        */
      let delta = event.wheelDelta
      if (!event.wheelDelta) {
        delta = event.detail
        zoom -= delta / 3 * 10;
      } else {
        zoom += delta / 12;
      }
      /* 最小范围 和 最大范围 的图片缩放尺度 */
      if (zoom >= this.minZoom && zoom < this.maxZoom) {
        this.mapZoom = zoom;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.heat-source {
  width: 1680px;
  overflow-x: hidden;
  height: 1100px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 830px;
  padding: 10px;
  margin: 20px;
  background: #fff;
  border-radius: 10px;
  position: relative;
  box-shadow: 0 0 5px rgba($color: #000000, $alpha: 0.1);
}
.img-box {
  position: absolute;
  top: 10px;
}
.hydrating,
.trap,
.collector,
.title-001,
.title-002,
.title-003,
.img-001,
.img-002 {
  position: absolute;
  top: 200px;
}
.hydrating {
  top: 30px;
  left: 106px;
}
.trap {
  top: 420px;
  left: 1110px;
}
.collector {
  top: 668px;
  left: 1280px;
}
.circulatingPump1,
.circulatingPump2,
.circulatingPump3,
.circulatingPump4,
.circulatingPump5 {
  width: 51px;
  height: 47px;
  background-image: url("../../../../assets/wuhai_img/a_Shuibeng_on.gif");
  background-size: contain;
  background-repeat: no-repeat;
}
.circulatingPump1.stop,
.circulatingPump2.stop,
.circulatingPump3.stop,
.circulatingPump4.stop,
.circulatingPump5.stop {
  background-image: url("../../../../assets/wuhai_img/a_Shuibeng_off.png");
}
.title-001,
.img-002 {
  top: 342px;
  left: 110px;
  span.title {
    i {
      display: inline-block;
      width: 20px;
      height: 20px;
      vertical-align: bottom;
      background-color: rgb(88, 195, 43);
      border-radius: 50%;
    }
    &:first-child {
      margin-left: -20px;
    }
    &:nth-child(2) {
      position: absolute;
      top: 209px;
      left: -20px;
    }
    i.alarm {
      background-color: indianred;
    }
  }
  p {
    font-size: 12px;
    &:nth-child(5) {
      position: absolute;
      top: 30px;
      left: 58px;
    }
    &:nth-child(6) {
      position: absolute;
      top: 236px;
      left: 58px;
    }
    label {
      font-weight: 100;
    }
    span {
      width: 58px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      display: block;
      border-radius: 4px;
      border: 1px solid rgb(143, 170, 220);
      color: rgb(143, 170, 220);
    }
  }
}
.circulatingPump2 {
  margin-top: 166px;
}
.img-001 {
  top: 338px;
  left: 302px;
  .boiler1,
  .boiler2 {
    width: 208px;
    height: 118px;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url("../../../../assets/wuhai_img/boiler_on.png");
  }
  .boiler1.stop,
  .boiler2.stop {
    background-image: url("../../../../assets/wuhai_img/boiler1_off.png");
  }
  .boiler2 {
    margin-top: 86px;
  }
  p {
    span {
      width: 56px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      display: block;
      border-radius: 4px;
      background-color: rgb(88, 195, 43);
      color: #fff;
    }
    .stop {
      background-color: indianred;
    }
    &:nth-child(1) {
      position: absolute;
      top: 112px;
    }
    &:nth-child(2) {
      position: absolute;
      top: 320px;
    }
  }
}
.title-002,
.title-003 {
  top: 96px;
  left: 412px;
  div {
    margin-top: 10px;
    border-radius: 4px;
    border: 1px solid rgb(34, 36, 133);
    padding: 10px;
    p {
      margin: 5px;
      label {
        font-size: 14px;
        font-weight: 400;
      }
      span {
        font-size: 14px;
        width: 58px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        display: inline-block;
        border-radius: 4px;
        border: 1px solid rgb(143, 170, 220);
        color: rgb(143, 170, 220);
      }
      .span-btn {
        border: none;
        background-color: rgb(143, 170, 220);
        color: #fff;
      }
      .stop {
        background-color: rgb(217, 217, 217);
      }
      .alarm {
        background-color: indianred;
      }
    }
  }
}
.title-003 {
  top: 654px;
}
.img-002 {
  left: 738px;
  top: 265px;
  span.title {
    &:nth-child(2) {
      top: 165px;
    }
    &:nth-child(3) {
      position: absolute;
      top: 316px;
      left: -24px;
      width: 126px;
    }
  }
  p {
    position: absolute;
    &:nth-child(7) {
      top: 34px;
      left: 56px;
    }
    &:nth-child(8) {
      top: 192px;
      left: 56px;
    }
    &:nth-child(9) {
      top: 350px;
      left: 56px;
    }
  }
}
.circulatingPump4,
.circulatingPump5 {
  margin-top: 113px;
}
</style>